<template>
  <section :class="['banner']">
    <img :src="imgUrl" alt="首页bannner" />
    <slot></slot>
  </section>
</template>
<script>
export default {
  props: {
    imgUrl: {
      type: String,
      required: true
    }
  }
};
</script>
<style lang="less" scoped>
.banner {
  position: relative;
  img {
    display: block;
    width: 100%;
  }
}
</style>
